import React, { FunctionComponent } from 'react';
import { Grid, Image } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  icon: {
    height: '1.6875em !important',
    width: '1.6872em !important',
    marginRight: '1rem !important',
    backgroundColor: '#fff !important',
  },
  header: {
    padding: '0 !important',
    margin: '.750rem 0 0 0 !important',
  },
  spacing: {
    padding: '0 !important',
    fontSize: '1rem !important',
    fontWeight: '500 !important',
  },
};

type Props = {
  content: string;
  src?: string;
  classes: ClassProp<typeof styles>;
};

const Header: FunctionComponent<Props> = ({ classes, content, src }) => (
  <Grid.Row className={classes.header}>
    <Grid.Column width={8} className={classes.spacing}>
      {src && <Image className={classes.icon} src={src} avatar rounded />}
      {content}
    </Grid.Column>
  </Grid.Row>
);

export default withStyles(styles)(Header);
